import standardAPI from '@/api/standard_items';

const state = {
  subscribers: [],
  subscribers_status: '',
  subscribers_MetaData: {},
  subscribers_page: 1,
  subscribers_perPage: 10,
};

const responseUrl = '/subscribers';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_subscribers ({ commit }, getOptions) {
    commit('SUBSCRIBERS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('SUBSCRIBERS_SUCCESS', response);
            commit('SUBSCRIBERS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('SUBSCRIBERS_READY');
            reject(response);
          } else {
            commit('SUBSCRIBERS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.subscribers_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.subscribers_perPage = max;
  },
  SUBSCRIBERS_READY: (state) => {
    state.subscribers_status = 'ready';
  },
  SUBSCRIBERS_REQUEST: (state) => {
    state.subscribers_status = 'loading';
  },
  SUBSCRIBERS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.subscribers_MetaData.meta = response.meta;
      state.subscribers_MetaData.links = response.links;
    }
    state.subscribers = response.data;
    state.subscribers_status = 'success';
  },
  SUBSCRIBERS_ERROR: (state) => {
    state.subscribers_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
